export default {
  methods: {
    routeAllowed() {
      if (this.funeralDetails?.funeral_type_id === 1) {
        this.$router.push({ name: "funeral-options" });
      }
    }
  }
};
